"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsSalesToJSON = exports.AnalyticsSalesFromJSONTyped = exports.AnalyticsSalesFromJSON = exports.instanceOfAnalyticsSales = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AnalyticsSales interface.
 */
function instanceOfAnalyticsSales(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAnalyticsSales = instanceOfAnalyticsSales;
function AnalyticsSalesFromJSON(json) {
    return AnalyticsSalesFromJSONTyped(json, false);
}
exports.AnalyticsSalesFromJSON = AnalyticsSalesFromJSON;
function AnalyticsSalesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': !(0, runtime_1.exists)(json, 'date') ? undefined : json['date'],
        'sales': !(0, runtime_1.exists)(json, 'sales') ? undefined : json['sales'],
        'vouchers': !(0, runtime_1.exists)(json, 'vouchers') ? undefined : json['vouchers'],
        'refunds': !(0, runtime_1.exists)(json, 'refunds') ? undefined : json['refunds'],
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : json['items'],
        'netSales': !(0, runtime_1.exists)(json, 'netSales') ? undefined : json['netSales'],
    };
}
exports.AnalyticsSalesFromJSONTyped = AnalyticsSalesFromJSONTyped;
function AnalyticsSalesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'sales': value.sales,
        'vouchers': value.vouchers,
        'refunds': value.refunds,
        'items': value.items,
        'netSales': value.netSales,
    };
}
exports.AnalyticsSalesToJSON = AnalyticsSalesToJSON;
